<template>
  <div class="modal fade" id="modalPaymentHistory" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="title-modal">Historico de pagamento.</h4>
        </div>

        <div class="modal-body">
          <form>
            <div class="form-group">
              <label>Mês</label>
              <input v-model="historyPayment.month" type="text" class="form-control" id="month" name="month" required/>
              <span v-if="error.month" class="error-msg">{{ error.month }}</span>
            </div>
            <div class="form-group">
              <label>Ano</label>
              <input v-model="historyPayment.year" type="text" class="form-control" id="year" name="year" required/>
              <span v-if="error.year" class="error-msg">{{ error.year }}</span>
            </div>
            <div class="form-group">
              <label>Observações</label>
              <textarea v-model="historyPayment.notes" class="form-control" name="description"> </textarea>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button v-on:click="sendEdit()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}"
                  type="submit" class="btn btn-register">
            <span v-if="!loadingChange">Enviar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modalPaymentHistory",
  props: ['objToModal'],
  data() {
    return {
      loadingChange: false,
      month: 0,
      error: {
        month: '',
        year: '',
      },
      historyPayment: {
        year: '',
        month: '',
        notes: ''
      },
      emitValue: null,
    }
  },
  watch: {
    objToModal: function (val) {
      this.historyPayment.id = val.id;
      this.historyPayment.year = val.yearReference;
      this.historyPayment.month = val.monthReference;
    },
    emitValue: function (val) {
      this.$emit('update:reloadFunction', val)
    }
  },
  methods: {
    closeModal() {
      $('#modalPaymentHistory').modal('toggle');
    },
    sendEdit() {
      this.error.month = "";

      if (this.historyPayment.month && this.historyPayment.year) {
        this.emitValue = this.historyPayment;
        this.closeModal();
      } else {
        if (this.month)
          this.error.month = "Preencha um valor.";
        if (this.year)
          this.error.year = "Preencha um valor.";
      }
    }
  }
}
</script>

<style lang="scss">
#modalPaymentHistory {
  .owner-select {
    width: 100%;

    select {
      border: 1px solid #999;
      border-radius: 5px;
      height: 34px;
      width: 100%;
      padding: 0 10px;
      cursor: pointer;
    }
  }

  .select-date {
    width: 100%;
    margin-top: 20px;

    p {
      font-size: 18px;
      padding-left: 1px;
    }

    .vdp-datepicker {
      display: inline-block;
      width: 100%;

      input {
        border: 1px solid #999;
        border-radius: 5px;
        height: 34px;
        width: 100%;
        padding: 0 10px;
        cursor: pointer;
      }
    }

    i {
      display: inline-block;
      position: relative;
      right: 15px;
      top: -23px;
      float: right;
      color: #111;
      cursor: pointer;
    }
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalPaymentHistory.vue